export default __webpack_public_path__ + "media/images/svg/pale-x-icon-round-524ac8acbe2588082832f451274125a3.svg";